// extracted by mini-css-extract-plugin
module.exports = {"sfaSponsorPill":"sfaSponsorPill_sfaSponsorPill__vpO8J","label":"sfaSponsorPill_label__Yh0Jy","logo":"sfaSponsorPill_logo__gvFrR"};